import {SidebarItemsType} from '../types/typeSidebar';
import {path} from './path';
import {images} from '../constants/image';
import {envRole} from '../utils';
import {USER_TYPE} from '../constants/UserType';
import {rbacPermissions} from '../constants/roleBasedAccessControlConstants';
const isAdministrator = +envRole === USER_TYPE.ADMINISTRATOR;

const DashboardNavRoutes: {title: string; pages: SidebarItemsType[]}[] = [
  {
    title: '',
    pages: [
      {
        href: `/${path.ISLAND_MEMBERS}`,
        icon: images.icon_members,
        title: 'Islander Members',
        subPage: true,
        requiredPermissions: [
          rbacPermissions.ISLANDER_MEMBERS__LISTING__VIEW,
          rbacPermissions.ISLANDER_MEMBERS__TERMINATED_MEMBERS__VIEW,
          rbacPermissions.ISLANDER_MEMBERS__WATCHLIST_TAGS__VIEW,
        ],
        children: [
          {
            href: `${path.ISLAND_MEMBERS}/${path.TERMINATED_MEMBERS}`,
            icon: images.icon_terminated_members,
            title: 'Terminated Members',
            requiredPermissions: [
              rbacPermissions.ISLANDER_MEMBERS__TERMINATED_MEMBERS__VIEW,
            ],
          },
          {
            href: `${path.ISLAND_MEMBERS}/${path.WATCHLIST_TAG}`,
            icon: images.icon_transaction,
            title: 'Watchlist Tags Values',
            requiredPermissions: [
              rbacPermissions.ISLANDER_MEMBERS__WATCHLIST_TAGS__VIEW,
            ],
          },
        ],
      },
      {
        href: `/${path.ISLAND_PARTNERS}`,
        icon: images.icon_partners,
        title: `Island Partner${isAdministrator ? 's' : ''}`,
        requiredPermissions: [rbacPermissions.ISLAND_PARTNERS__LISTING__VIEW],
      },
      {
        href: `/${path.PORTAL_USERS}`,
        icon: images.icon_sdc_admin,
        title: 'Portal Users',
        requiredPermissions: [rbacPermissions.ADMINISTRATORS__LISTING__VIEW],
      },
      {
        href: `/${path.ALL_TRANSACTION}`,
        icon: images.icon_transaction,
        title: 'All Transaction',
        isDropdown: isAdministrator,
        subPage: true,
        requiredPermissions: [
          rbacPermissions.POINTS_TRANSACTIONS__LISTING__VIEW,
          rbacPermissions.POINTS_TRANSACTIONS__RECEIPT_VALIDATION__VIEW,
        ],
        children: [
          {
            href: `/${path.ALL_TRANSACTION}/${path.RECEIPT_VALIDATION_LOGS}`,
            icon: images.icon_transaction,
            title: 'Receipt Validation Logs',
            requiredPermissions: [
              rbacPermissions.POINTS_TRANSACTIONS__RECEIPT_VALIDATION__VIEW,
            ],
          },
        ],
      },
      {
        href: `/${path.LIMITED_EVENT}`,
        icon: images.icon_transaction,
        title: 'Limited Events',
        requiredPermissions: [
          rbacPermissions.POINTS_MULTIPLIER_EVENT__LISTING__VIEW,
        ],
      },
      {
        href: `/${path.REFERRAL_PROGRAMME}`,
        icon: images.icon_transaction,
        title: 'Referral Programme',
        requiredPermissions: [
          rbacPermissions.REFERRAL_PROGRAMME__PARTNERSHIPS__VIEW,
          rbacPermissions.REFERRAL_PROGRAMME__ISLANDER_MEMBERS__VIEW,
          rbacPermissions.REFERRAL_PROGRAMME__REFERRAL_TRANSACTIONS__VIEW,
        ],
        children: [
          {
            href: `/${path.REFERRAL_PROGRAMME}/${path.PARTNERSHIP}`,
            icon: images.icon_partners,
            title: 'Partnership',
            requiredPermissions: [
              rbacPermissions.REFERRAL_PROGRAMME__PARTNERSHIPS__VIEW,
            ],
          },
          {
            href: `/${path.REFERRAL_PROGRAMME}/${path.ISLANDER_MEMBER}`,
            icon: images.icon_members,
            title: 'Islander Member',
            requiredPermissions: [
              rbacPermissions.REFERRAL_PROGRAMME__ISLANDER_MEMBERS__VIEW,
            ],
          },
          {
            href: `/${path.REFERRAL_PROGRAMME}/${path.REFERRAL_TRANSACTIONS}`,
            icon: images.icon_transaction,
            title: 'Referral Transactions',
            requiredPermissions: [
              rbacPermissions.REFERRAL_PROGRAMME__REFERRAL_TRANSACTIONS__VIEW,
            ],
          },
        ],
      },
      {
        href: `/${path.VOUCHER_TRANSACTION_HISTORY}`,
        icon: images.icon_voucher_transaction,
        title: 'Voucher Transaction',
        requiredPermissions: [
          rbacPermissions.VOUCHER_TRANSACTIONS__LISTING__VIEW,
        ],
      },
      {
        href: `/${path.VOUCHER}`,
        icon: images.icon_voucher,
        title: 'Voucher',
        subPage: true,
        requiredPermissions: [
          rbacPermissions.VOUCHERS__LISTING__VIEW,
          rbacPermissions.VOUCHERS__FEATURED_VOUCHERS__VIEW,
          rbacPermissions.VOUCHERS__TARGETED_DISTRIBUTIONS__EXECUTE,
          rbacPermissions.VOUCHERS__TARGETED_DISTRIBUTION_LOGS__VIEW,
          rbacPermissions.VOUCHERS__VOUCHER_CATEGORIES__VIEW,
          rbacPermissions.VOUCHERS__VOUCHER_CATEGORIES__CREATE,
          rbacPermissions.VOUCHERS__VOUCHER_CATEGORIES__EDIT,
        ],
        children: [
          {
            href: `/${path.VOUCHER}/${path.FEATURED_VOUCHER}`,
            icon: images.icon_featured_voucher,
            title: 'Featured Voucher',
            requiredPermissions: [
              rbacPermissions.VOUCHERS__FEATURED_VOUCHERS__VIEW,
            ],
          },
          {
            href: `/${path.VOUCHER}/${path.TARGETED_DISTRIBUTIONS}`,
            icon: images.icon_targeted_distribution,
            title: 'Targeted Distribution',
            requiredPermissions: [
              rbacPermissions.VOUCHERS__TARGETED_DISTRIBUTIONS__EXECUTE,
            ],
          },
          {
            href: `/${path.VOUCHER}/${path.DISTRIBUTION_LOGS}`,
            icon: images.icon_distribution_logs,
            title: 'Distribution Logs',
            requiredPermissions: [
              rbacPermissions.VOUCHERS__TARGETED_DISTRIBUTION_LOGS__VIEW,
            ],
          },
          {
            href: `/${path.VOUCHER}/${path.VOUCHER_CATEGORIES}`,
            icon: images.icon_voucher_categories,
            title: 'Voucher Categories',
            tierChildren: 1,
            requiredPermissions: [
              rbacPermissions.VOUCHERS__VOUCHER_CATEGORIES__VIEW,
              rbacPermissions.VOUCHERS__VOUCHER_CATEGORIES__CREATE,
            ],
            children: [
              {
                href: `/${path.VOUCHER}/${path.VOUCHER_CATEGORIES}/${path.VOUCHER_CATEGORIES_ADD_NEW}`,
                icon: images.icon_add_new_categories,
                title: 'Add new',
                requiredPermissions: [
                  rbacPermissions.VOUCHERS__VOUCHER_CATEGORIES__CREATE,
                ],
              },
              {
                href: `/${path.VOUCHER}/${path.VOUCHER_CATEGORIES}/${path.VOUCHER_CATEGORIES_MANAGE}`,
                icon: images.icon_manage_categories,
                title: 'Manage categories',
                requiredPermissions: [
                  rbacPermissions.VOUCHERS__VOUCHER_CATEGORIES__VIEW,
                ],
              },
            ],
          },
        ],
      },
      {
        href: `/${path.MOBILE_APP_CMS}`,
        icon: images.icon_mobile_app_cms,
        title: 'Mobile App CMS',
        requiredPermissions: [
          rbacPermissions.MOBILE_APP_CMS__EVENTS__VIEW,
          rbacPermissions.MOBILE_APP_CMS__ARTICLES__VIEW,
          rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__VIEW,
          rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__CREATE,
          rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__EDIT,
          rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__DELETE,
          rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__VIEW,
          rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__CREATE,
          rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__DELETE,
        ],
        children: [
          {
            href: `/${path.MOBILE_APP_CMS}/${path.EVENTS}`,
            icon: images.icon_partners,
            title: 'Event',
            requiredPermissions: [rbacPermissions.MOBILE_APP_CMS__EVENTS__VIEW],
          },
          {
            href: `/${path.MOBILE_APP_CMS}/${path.ARTICLE}`,
            icon: images.icon_members,
            title: 'Article',
            requiredPermissions: [
              rbacPermissions.MOBILE_APP_CMS__ARTICLES__VIEW,
            ],
          },
          {
            href: `/${path.MOBILE_APP_CMS}/${path.MEMBER_DASHBOARD}`,
            icon: images.icon_member_dashboard,
            title: 'Member Dashboard',
            tierChildren: 1,
            requiredPermissions: [
              rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__VIEW,
              rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__CREATE,
              rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__EDIT,
              rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__DELETE,
            ],
            children: [
              {
                href: `/${path.MOBILE_APP_CMS}/${path.MEMBER_DASHBOARD}/${path.MEMBER_DASHBOARD_CREATE_NEW}`,
                icon: images.icon_member_dashboard_create_new,
                title: 'Create New',
                requiredPermissions: [
                  rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__CREATE,
                ],
              },
              {
                href: `/${path.MOBILE_APP_CMS}/${path.MEMBER_DASHBOARD}/${path.MEMBER_DASHBOARD_MANAGE_LIVE}`,
                icon: images.icon_manage_live,
                title: 'Manage Live',
                requiredPermissions: [
                  rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__VIEW,
                  rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__EDIT,
                  rbacPermissions.MOBILE_APP_CMS__MEMBER_DASHBOARD__DELETE,
                ],
              },
            ],
          },
          {
            href: `/${path.MOBILE_APP_CMS}/${path.MEDIA_LIBRARY}`,
            icon: images.icon_media_library,
            title: 'Media Library',
            tierChildren: 1,
            requiredPermissions: [
              rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__VIEW,
              rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__CREATE,
              rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__DELETE,
            ],
            children: [
              {
                href: `/${path.MOBILE_APP_CMS}/${path.MEDIA_LIBRARY}/${path.UPLOAD_NEW}`,
                icon: images.icon_upload_new,
                title: 'Upload New',
                requiredPermissions: [
                  rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__CREATE,
                ],
              },
              {
                href: `/${path.MOBILE_APP_CMS}/${path.MEDIA_LIBRARY}/${path.MOBILE_ASSETS}`,
                icon: images.icon_manage_assets,
                title: 'Manage Assets',
                requiredPermissions: [
                  rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__VIEW,
                  rbacPermissions.MOBILE_APP_CMS__MEDIA_LIBRARY__DELETE,
                ],
              },
            ],
          },
        ],
      },
      {
        href: `/${path.AUDIT_LOGS}`,
        icon: images.icon_audit_logs,
        title: 'Audit Logs',
        requiredPermissions: [rbacPermissions.AUDIT__ADMIN_LOGS__VIEW],
      },
      {
        href: `/${path.AUDIT_LOGS_MEMBERS}`,
        icon: images.icon_audit_logs,
        title: 'Audit Logs Members',
        requiredPermissions: [rbacPermissions.AUDIT__MEMBER_LOGS__VIEW],
      },
    ],
  },
];

export default DashboardNavRoutes;
